import { apiClient } from './client';
import type {
  AuthTokens,
  LoginResponse,
  ModuleAccess,
  PaginatedResponse,
  User,
  UserRole,
} from '../types/api';

export interface CreateUserPayload {
  email: string;
  password: string;
  first_name?: string;
  last_name?: string;
  role?: UserRole;
  is_active?: boolean;
  module_access?: ModuleAccess;
}

export interface UpdateUserPayload {
  first_name?: string;
  last_name?: string;
  role?: UserRole;
  is_active?: boolean;
  module_access?: ModuleAccess;
  password?: string;
}

export const authApi = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>('/auth/login/', { email, password });
    return response.data;
  },

  async logout(refresh: string): Promise<void> {
    await apiClient.post('/auth/logout/', { refresh });
  },

  async refresh(refresh: string): Promise<AuthTokens> {
    const response = await apiClient.post<AuthTokens>('/auth/refresh/', { refresh });
    return response.data;
  },

  async me(): Promise<User> {
    const response = await apiClient.get<User>('/auth/me/');
    return response.data;
  },

  /** Власний профіль: поки що лише мова назв виробів. */
  async updateMe(payload: Pick<User, 'product_name_language'>): Promise<User> {
    const response = await apiClient.patch<User>('/auth/me/', payload);
    return response.data;
  },

  // ── User management (admin only) ──
  async listUsers(): Promise<User[]> {
    const response = await apiClient.get<PaginatedResponse<User> | User[]>('/auth/users/', {
      params: { page_size: 200 },
    });
    return Array.isArray(response.data) ? response.data : response.data.results;
  },

  async createUser(payload: CreateUserPayload): Promise<User> {
    const response = await apiClient.post<User>('/auth/users/', payload);
    return response.data;
  },

  async updateUser(id: number, payload: UpdateUserPayload): Promise<User> {
    const response = await apiClient.patch<User>(`/auth/users/${id}/`, payload);
    return response.data;
  },
};
